const ArrowLeft = () => {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.37341 1.20349L0.57687 5.00003L4.37341 8.79658"
        stroke="currentColor"
        strokeWidth="0.769231"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M0.576927 5L8.65381 5"
        stroke="currentColor"
        strokeWidth="0.769231"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ArrowLeft;
